@if (surveyModel()) {
  <div class="survey-viewer__container">
    <div class="survey-viewer__content" @openingAnimation>
      @if (testMode()) {
        <div class="survey-viewer__test">
          <div class="survey-viewer__test__banner">
            <fa-icon [icon]="faMessageExclamation"></fa-icon>
            <div class="survey-viewer__test__banner__text">
              <span class="fs__sm fw__500">Test</span>
            </div>
          </div>
        </div>
      }

      @if (showEndPage$()) {
        <empathy-end-page-view
          class="survey-viewer__survey"
          [terminatedBy]="terminatedBy$()"
          [surveyModel]="surveyModel()"
          (completed)="completed.emit($event)"
        ></empathy-end-page-view>
      } @else if (showFeedbackPage$()) {
        <empathy-feedback-view [surveyModel]="surveyModel()" (completed)="onSubmitFeedback($event)"></empathy-feedback-view>
      } @else {
        @if (!isPreparing$()) {
          @if (showWelcomePage$()) {
            <empathy-welcome-page-view [surveyModel]="surveyModel()" (start)="onNext()"></empathy-welcome-page-view>
          } @else {
            <empathy-page-view
              class="survey-viewer__survey"
              [autoSubmitting]="autoSubmitting$()"
              [page]="activePage$()"
              [questionCtrls]="questionCtrls$()"
              [showCompleteButton]="showCompleteButton$()"
              [isSaving]="isSaving$()"
              [submitting]="submitting()"
              [progress]="progressValue$()"
              (httpError)="httpError.emit()"
              (prev)="onPrev()"
              (next)="onNext()"
            ></empathy-page-view>
          }
        }
      }
    </div>
  </div>
}
